module.exports = new __parcel__URL__("grandtitan.e72d042b.png").toString();